import { render, staticRenderFns } from "./ConsequenceCard.vue?vue&type=template&id=711900e8&scoped=true"
import script from "./ConsequenceCard.vue?vue&type=script&lang=js"
export * from "./ConsequenceCard.vue?vue&type=script&lang=js"
import style0 from "./ConsequenceCard.vue?vue&type=style&index=0&id=711900e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711900e8",
  null
  
)

export default component.exports